import { Button } from '@lune-fe/lune-ui-lib'
import { FC, useState } from 'react'

import { downloadPdf } from 'endpoints/dapi'

const DownloadPdfButton: FC<{
    id: string
    token: string
    isMultiLeg: boolean
}> = ({ id, token, isMultiLeg }) => {
    const [downloading, setDownloading] = useState<boolean>(false)
    return (
        <Button
            disabled={downloading}
            variant={'text'}
            onClick={() => {
                setDownloading(true)
                const originalUrl = window.location.origin
                const urlToDownload = isMultiLeg
                    ? `multi-leg-shipping/${id}/results/pdf/${token}`
                    : `logistics-emissions/${id}/pdf/${token}`
                const fileName = `emission-estimate-calculation-${id}`
                downloadPdf(
                    `${originalUrl}/calculate-emissions/${urlToDownload}`,
                    fileName,
                ).finally(() => setDownloading(false))
            }}
        >
            Download PDF
        </Button>
    )
}

export default DownloadPdfButton
